import { Controller } from "@hotwired/stimulus"

// Says what the typed odometer means before it is sent: how far past the last
// reading it is, or that it is lower, or a suspiciously big jump. ADVISORY
// only -- OdometerReading's validation decides, and says the same things in
// full sentences if the form is sent anyway.
//
// Markup contract:
//   <form data-controller="odometer-helper"
//         data-odometer-helper-last-value="48210"        (absent: no reading yet)
//         data-odometer-helper-max-jump-value="5000">
//     <input data-odometer-helper-target="input" data-action="odometer-helper#update">
//     <p data-odometer-helper-target="hint" aria-live="polite">Last reading 48,210 on Sep 3</p>
export default class extends Controller {
  static targets = ["input", "hint"]
  static values = { last: Number, maxJump: Number }

  connect() {
    // What the server rendered, restored when the field is emptied again.
    this.initialHint = this.hintTarget.textContent.trim()
  }

  update() {
    const digits = this.inputTarget.value.replace(/[^\d]/g, "")
    if (!digits || !this.hasLastValue) return this.say(this.initialHint)

    const miles = parseInt(digits, 10)
    const delta = miles - this.lastValue
    const last = this.lastValue.toLocaleString("en-US")

    if (delta < 0) {
      this.say(`Lower than the last reading, ${last}`)
    } else if (this.maxJumpValue && delta > this.maxJumpValue) {
      this.say(`${delta.toLocaleString("en-US")} mi more than the last reading (${last}). Check it for a typo`)
    } else {
      this.say(`+${delta.toLocaleString("en-US")} mi since the last reading, ${last}`)
    }
  }

  say(text) {
    this.hintTarget.textContent = text
  }
}
